// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table-height .collectTimeList {\n  padding: 0;\n}\n.table-height .collectTimeList .cell {\n  padding-left: 0;\n  padding-right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
